import prefixes from '@zazuko/rdf-vocabularies/prefixes';
import morePrefixes from "./prefixes.mjs";
Object.entries(morePrefixes).forEach(([prefix, namespace]) => {
  prefixes[prefix] = namespace;
});